export const AI_BRANDNAME = 'Atlassian Intelligence';

export const AI_CONTAINER_BORDER_RADIUS = 8;
export const AI_CONTAINER_INNER_BORDER_RADIUS = 6;
export const AI_CONTAINER_LARGE_INNER_BORDER_RADIUS = 7;

export const FEEDBACK_LIKE = 'LIKE';
export const FEEDBACK_DISLIKE = 'DISLIKE';
export const LEARN_MORE_URL =
	'https://support.atlassian.com/organization-administration/docs/get-started-with-atlassian-intelligence/';
